import { render, staticRenderFns } from "./PromptCard.vue?vue&type=template&id=04a0d2ff&scoped=true&"
import script from "./PromptCard.vue?vue&type=script&lang=js&"
export * from "./PromptCard.vue?vue&type=script&lang=js&"
import style0 from "./PromptCard.vue?vue&type=style&index=0&id=04a0d2ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a0d2ff",
  null
  
)

export default component.exports